import React, {useContext, useState} from 'react'
import {dataContext,localestr, } from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js';
import EditFld from '../cmp/EditFld.js';
import Panel from '../cmp/Panel'
import FldModifiers from './FldModifiers'
import CatModifiers from './CatModifiers'
import icon from '../icons.svg'
import EditImg from '../cmp/EditImg.js';

function FldGoodsEdit({data,actions}){
    let wndData=''
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabChoice=actions.tabChoice
    const tabClose=actions.tabClose
    const context=useContext(dataContext)
    const saveData=context.saveData
    const msg=context.msg
    const newTWnd=context.newTWnd
    const langs=context.data['sysConst']['langs']
    const loaddata=context.loaddata
    const generateTranslations = () => {
        if (!langs || langs.length === 0 || langs.every(l => Number(l.is_used) === 0)) {
            msg(localestr('Оберіть мову для перекладу в налаштуванням онлайн меню'), localestr('Помилка'), [{
                caption: 'OK',
                action: () => {}
            }]);
            return;
        }
    
        const selectedLangs = langs.filter(l => Number(l.is_used) === 1).map(i => i.code);
        let newData = {...wndData, changed: true};
        if (!wndData.id) {
            
            /*const translations = wndData.translations ?? selectedLangs.reduce((acc, lang) => {
                acc[lang] = {};
                return acc;
            }, {});*/

            let items = [{
                type: 4,
                data: [{
                    id: 0,
                    name: wndData?.name ?? '',
                }],
                fields: ['name',]
            }];
    
            if (wndData?.modifiers) {
                const modifiers = Object.values(
                    (wndData?.modifiers || []).reduce((acc, item) => {
                        if (item.child?.length > 0) {
                        acc[5] = acc[5] || { type: 5, data: [], fields: ['name'] };
                        acc[5].data.push({
                            id: item.uid,
                            name: item.name 
                        });
                        acc[6] = acc[6] || { type: 6, data: [], fields: ['name'] };
                        item.child.forEach(child => {
                            acc[6].data.push({
                            id: child.uid,
                            name: child.name
                            });
                        });
                        } else {
                        acc[6] = acc[6] || { type: 6, data: [], fields: ['name'] };
                        acc[6].data.push({
                            id: item.uid,
                            name: item.name
                        });
                        }
                    
                        return acc;
                    }, {})
                );
                items = items.concat(modifiers);
            }
            loaddata(
                `action=translation&data=${JSON.stringify({
                    langs: selectedLangs,
                    items,
                    new: true
                })}`,
                undefined,
                (d) => processTranslationData(d, newData)
            );
        } else {
            const modifiers = wndData?.modifiers ? 
                Object.values(wndData.modifiers.reduce((acc, item) => {
                    if (item.child?.length > 0) {
                        acc[5] = acc[5] || {type: 5, ids: []};
                        acc[5].ids.push(parseInt(item.id));
                        acc[6] = acc[6] || {type: 6, ids: []};
                        acc[6].ids.push(...item.child.map(child => parseInt(child.id)));
                    } else {
                        acc[6] = acc[6] || {type: 6, ids: []};
                        acc[6].ids.push(parseInt(item.id));
                    }
                    return acc;
                }, {})) : [];
    
            loaddata(
                `action=translation&data=${JSON.stringify({
                    langs: selectedLangs,
                    entities: [{type: 4, ids: [wndData.id]}, ...modifiers]
                })}`,
                undefined,
                (d) => processTranslationData(d, newData)
            );
        }
    };
    
    const processTranslationData = (responseData, newData) => {
        newData.translations = {
            en: {name: '', modifiers: {}},
            de: {name: '', modifiers: {}},
            it: {name: '', modifiers: {}},
            hu: {name: '', modifiers: {}}
        };
        if (responseData.data['4']) {
            for (const key in responseData.data['4']) {
                const product = responseData.data['4'][key];
                for (const lang in product) {
                    if (newData.translations[lang]) {
                        newData.translations[lang].name = product[lang]?.name || '';
                        newData.translations[lang].type = 4;
                    }
                }
            }
        }
        for (const modifierTypeKey in responseData.data) {
            const modifierType = parseInt(modifierTypeKey);
            if (isNaN(modifierType) || modifierType === 4) continue;

            const modifiers = responseData.data[modifierTypeKey];
            for (const modifierId in modifiers) {
                const modifierData = modifiers[modifierId];
                for (const lang in modifierData) {
                    if (newData.translations[lang]) {
                        newData.translations[lang].modifiers[modifierId] = {
                            name: modifierData[lang]?.name || '',
                            type: modifierType.toString()
                        };
                    }
                }
            }
        }
        setWndData(newData, true);
    };

    const setValue=(name,data)=>{
        let newData={...wndData,changed:true}
        if (data==='') newData[name]=null
        else newData[name]=data
        if(name==='fiscal' && data.device) if(parseInt(data.device.value)<4) {msg(localestr('Недопустимий тип пристрою'),localestr('Помилка'),[{caption:'OK',action:()=>{}}]);return}
        setWndData(newData)
    }

    const setTranslationValue = (name, code, data) => {
        let newData={...wndData,changed:true}
        // console.log(name, code, data);
        let translations=wndData.translations || {}
        if (!translations[code]) translations[code]={name:"", type: 4, modifiers: {}}
        if (data==='') translations[code][name]=null
        else if (name==='modifiers'){
            const mod_translate={...(translations[code].modifiers||{})}
            mod_translate[data.id]=data.data
            translations[code][name]=mod_translate;
        }
        else translations[code][name] = data
        newData['translations'] = translations
        setWndData(newData,true)
    }

    const [activeTab, setActiveTab] = useState((langs||[]).find(l => l.code !== 'uk')?.code || '');
    let langs_cont=''
    if(langs?.length>0) {
        let modifiers_cont=''

        if(wndData?.modifiers?.length > 0){
            modifiers_cont=<Panel caption={localestr('Переклади модифікаторів')} width={792} open={wndData.p_lang_modifiers===undefined?false:wndData.p_lang_modifiers} setOpen={d=>setWndData({...wndData,p_lang_modifiers:d})}>
                <div style={{marginTop:"3px",maxWidth:'992px',flexGrow:492}}>
                {wndData.modifiers.map(item => {
                    if (item.type===0) {
                        return <div key={item.id ?? item.uid} style={{}}>
                            <div style={{padding:"2px"}}><EditCtrl Capt={localestr(item.name)} Value={wndData?.translations?.[activeTab]?.modifiers?.[item.id ?? item.uid]?.name || ""} 
                            typeVal={'text'} setVal={(d)=>{setTranslationValue('modifiers',activeTab,{id:item.id ?? item.uid,data:{type:5,name:d}})}} width1='250' width2='450'/></div>
                            {item.child ? item.child.map((item2) => (
                                <div key={item2.id ?? item2.uid} style={{padding:"2px"}}>
                                <EditCtrl Capt={localestr(item2.name)} Value={wndData?.translations?.[activeTab]?.modifiers?.[item2.id ?? item2.uid]?.name || ""} 
                                typeVal={'text'} setVal={(d)=>{setTranslationValue('modifiers',activeTab,{id:item2.id ?? item2.uid,data:{type:6,name:d}})}} width1='250' width2='450'/></div>)) 
                            : <div>(пусто)</div>}
                        </div>
                    }
                    return <div key={item.id ?? item.uid} style={{padding: "2px"}}>
                            <EditCtrl Capt={localestr(item.name)} Value={wndData?.translations?.[activeTab]?.modifiers?.[item.id ?? item.uid]?.name || ""} 
                            typeVal={'text'} setVal={(d)=>{setTranslationValue('modifiers',activeTab,{id:item.id ?? item.uid,data:{type:6,name:d}})}} width1='250' width2='450'/>
                        </div>;
                })}
                </div>
            </Panel>
        }
        langs_cont=<Panel caption={localestr('Переклади')} width={792} open={wndData.p_lang===undefined?false:wndData.p_lang} setOpen={d=>setWndData({...wndData,p_lang:d})}>
            <div style={{ display: 'flex', gap: '2px' }}>
                {langs.map(item => item.code !== 'uk' ? (
                    <button key={item.code} onClick={() => setActiveTab(item.code)} 
                        className={`tabbuton ${activeTab === item.code && "active"}`}
                        style={{maxWidth: "150px", padding: "0px" }}>{item.name}</button>
                    ) : null
                )}
            </div>
            {langs.map(item =>
                item.code !== 'uk' && item.code === activeTab ? (
                    <div key={item.id} style={{margin:'2px 0',display:'inherit'}}>
                    <div style={{margin:'0',display:'inherit',flexDirection:'column',width:'492px',maxWidth:'1300px',flexGrow:492}}>
                        <EditCtrl Capt={localestr('Назва')} Value={wndData?.translations?.[item.code]?.name || ""} typeVal={'text'} 
                        setVal={(d)=>{setTranslationValue('name',item.code,d)}} width1='92' width2='404'/>
                    </div>
                    </div>
                ) : null
            )}
            {modifiers_cont?modifiers_cont:null}
            <div className='no-print' style={{margin:'0',minWidth:'337px',display:'flex',justifyContent:'center',flexGrow:'100000'}}>
                <div style={{width:'250px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} 
                onClick={()=>generateTranslations()}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>
                {localestr('Згенерувати автопереклад')}</div></div>
            </div>
        </Panel>
    }

    const saveValue=()=>{
        let errmsg=''
        const name=(wndData.name || '').substring(0,50)
        const parent=wndData.parent || {id:null,name:null}
        const fiscal=wndData.fiscal || {id:null,name:null}
        const hall=wndData.hall || {id:null,name:null}
        const small_img=(wndData.small_img || '').replace(/\+/g,' ')
        const colour=wndData.colour ? wndData.colour.src : null
        const sorting=wndData.sort || null
        const package_=wndData.package || null
        const id=wndData.id
        const modifiers=wndData.modifiers || null;
        const translations = wndData.translations;

        if (name===null || name==='') errmsg=localestr("Не заповнено ім'я")
        if (parent.id===id && id) errmsg=errmsg+localestr("Некоректна папка")
        if (parent.parent) {
            if (parent.parent.id===id && id) errmsg=errmsg+localestr("Некоректна папка")
            if(parent.parent.parent){
                if (parent.parent.parent.id===id && id) errmsg=errmsg+localestr("Некоректна папка")
                if(parent.parent.parent.parent){
                    if (parent.parent.parent.parent.id===id && id) errmsg=errmsg+localestr("Некоректна папка")
                    if(parent.parent.parent.parent.parent){
                        if (parent.parent.parent.parent.parent.id===id && id) errmsg=errmsg+localestr("Некоректна папка")
                        
                    }
                }
            }
        }
        if (errmsg!=='') msg(errmsg,localestr('Помилка'),[{caption:'OK',action:()=>{}}])
        else{
            if (id===null || id==='' || id===undefined){
                let newData={status:'add',key:'FldGoods',data:{name,parent,fiscal,colour,sorting,hall,small_img,modifiers,package:package_, translations: {...translations}}}
                saveData(newData,d=>{if(wndData.update) wndData.update(d.data);if(tabChoice) tabChoice(d.data);tabClose()})
                //почекати ы закрити выкно
            }  
            else if(wndData.changed) {
                let newData={status:'mod',key:'FldGoods',data:{id,name,parent,fiscal,colour,sorting,hall,small_img,modifiers,package:package_, translations: {...translations}}}
                saveData(newData,d=>{if(wndData.update) wndData.update(d.data);tabClose()})//
            }        
            else tabClose()
        }

    }

    let modCont=null
    const modSorting=(a, b)=>{ //сортування модифікаторів 
        if(a.sorting<b.sorting) return -1
        if(a.sorting>b.sorting) return 1
        if(a.name<b.name) return -1
        if(a.name>b.name) return 1
        return 0
    }

    let tmpData=[]
    if(wndData.modifiers) tmpData=[...wndData.modifiers].filter(el=>el.hide!==true)
    
    tmpData.sort(modSorting)

    modCont=tmpData.map((grp,i)=>{
        let modItems=null
        let chlData=[]
        if(grp.child) chlData=[...grp.child].filter(el=>el.hide!==true)
        chlData.sort(modSorting)
        if(grp.type<2){
            modItems=chlData.map((el,k)=>{
                let price=null
                if(el.price>0) price=<div>{localestr('ціна ')+'+'+el.price}</div>
                else if(el.price<0) price=<div>{localestr('ціна ')+el.price}</div>
                return(<div key={i+'id'+k} style={{paddingLeft:'20px',fontStyle:'italic',display:'flex'}}>
                    <div style={{flexGrow:'200'}}><input id={i+'id'+k} type={grp.type?'radio':'checkbox'} checked={el.type===2?0:1} onChange={()=>{modCheckItem(grp,el)}} />
                    <label htmlFor={i+'id'+k}>{el.name}</label></div>{price}
                    <div style={{paddingLeft:'10px'}}><img style={{width:'16px',height:'16px'}} src={icon+'#catArts'} alt={''} onClick={()=>{modItemEdit(grp,el)}}/>
                    <img style={{width:'16px',height:'16px',marginLeft:'8px'}} src={icon+'#dlt'} alt={''} onClick={()=>{msg(localestr('Ви дійсно бажаєте видалити модифікатор?'),null,[{caption:'OK',action:()=>{modDelItem(grp,el)}},{caption:localestr('Відмінити'),action:()=>{}}])}}/></div></div>)
            } 
            )
            return(<div key={i} style={{border:'1px solid #0008',borderRadius:'5px',marginTop:'3px'}}>
                <div style={{background:'#0001',display:'flex',height:'24px'}}><div style={{paddingLeft:'2px',flexGrow:'200'}}>{grp.name}</div><div style={{paddingLeft:'10px'}}><img style={{width:'16px',height:'16px'}} src={icon+'#catArts'} alt={''} onClick={()=>{modGroupEdit(grp)}}/>
                <img style={{width:'16px',height:'16px',marginLeft:'8px'}} src={icon+'#dlt'} alt={''} onClick={()=>{msg(localestr('Ви дійсно бажаєте видалити групу модифікаторів?'),null,[{caption:'OK',action:()=>{modDelItem(grp)}},{caption:localestr('Відмінити'),action:()=>{}}])}}/></div></div>{modItems}
                <div className='no-print' style={{margin:'0',minWidth:'337px',display:'flex',justifyContent:'center',flexGrow:'100000'}}>
                    <div style={{width:'190px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{modItemEdit(grp,null)}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Новий модифікатор')}</div></div>
                </div>
                </div>
            )
        }
        else {
            let price=null
            if(grp.price>0) price=<div>{localestr('ціна ')+'+'+grp.price}</div>
            else if(grp.price<0) price=<div>{localestr('ціна ')+grp.price}</div>
        return(
            <div key={i} style={{paddingLeft:'20px',fontStyle:'italic',display:'flex'}}>
                    <div style={{flexGrow:'200'}}><input id={i} type='checkbox' checked={grp.type===4?0:1} onChange={()=>{modCheckItem(null,grp)}} />
                    <label htmlFor={i}>{grp.name}</label></div>{price}
                    <div style={{paddingLeft:'10px'}}><img style={{width:'16px',height:'16px'}} src={icon+'#catArts'} alt={''} onClick={()=>{modItemEdit(null,grp)}}/>
                    <img style={{width:'16px',height:'16px',marginLeft:'8px'}} src={icon+'#dlt'} alt={''} onClick={()=>{msg(localestr('Ви дійсно бажаєте видалити модифікатор?'),null,[{caption:'OK',action:()=>{modDelItem(null,grp)}},{caption:localestr('Відмінити'),action:()=>{}}])}}/></div></div>
        )}                
    })

    const modGroupEdit=(grp)=>{
        let cont=<FldModifiers data={grp} action={data=>{if(Object.keys(data).length) modSaveItem(data)}}/>
        newTWnd(cont,localestr('Група модифікаторів'))
    }

    const modItemEdit=(grp,itm)=>{
        let cont=<CatModifiers group={grp} data={itm} goodName={wndData.menu_name} action={(grp,data)=>{if(Object.keys(data).length) modSaveItem(grp,data)}}/>
        newTWnd(cont,localestr('Модифікатор'))
    }

    const modItemEdit4=(grp,itm)=>{
        let cont=<CatModifiers group={grp} data={itm} type={4} goodName={wndData.menu_name} action={(grp,data)=>{if(Object.keys(data).length) modSaveItem(grp,data)}}/>
        newTWnd(cont,localestr('Модифікатор'))
    }

    //Збереження модифікатора: якщо передана лише група - зберігаємо її, інакше зберігаємо лише елемент. нові додаємо в кінець
    const modSaveItem=(grp,itm)=>{
        let newModifiers=[]
        if(wndData.modifiers) newModifiers=[...wndData.modifiers]
        let grpIdx=-1
        if(grp) grpIdx=newModifiers.findIndex(el=>el.uid===grp.uid)
        if(itm&&grpIdx!==-1){
            let itmIdx=-1
            if(newModifiers[grpIdx].child) itmIdx=newModifiers[grpIdx].child.findIndex(el=>el.uid===itm.uid)
            if(itmIdx!==-1) {
                const newItem={...newModifiers[grpIdx].child[itmIdx],...itm}
                newModifiers[grpIdx].child[itmIdx]=newItem
            } else {
                if(!newModifiers[grpIdx].child) newModifiers[grpIdx].child=[]
                const newItem={...itm,sorting:(newModifiers[grpIdx].child||[]).length}
                newModifiers[grpIdx].child.push(newItem)
            }
        }
        else if(itm&&itm.type>3){
            grpIdx=newModifiers.findIndex(el=>el.uid===itm.uid)
            if(grpIdx!==-1) {
                const newItem={...newModifiers[grpIdx],...itm}
                newModifiers[grpIdx]=newItem
            } else {
                const newItem={...itm,sorting:newModifiers.length}
                newModifiers.push(newItem)
            }
        }
        else if(grp){
            if(grpIdx!==-1) {
                const newItem={...newModifiers[grpIdx],...grp}
                newModifiers[grpIdx]=newItem
            } else {
                const newItem={...grp,sorting:newModifiers.length}
                newModifiers.push(newItem)
            }
        }
        let newData={...wndData,modifiers:newModifiers,changed:true}
        setWndData(newData)
    }

    //видалення: помічаємо елемент і перенумеровуємо всі після нього
    const modDelItem=(grp,itm)=>{
        let newModifiers=[]
        if(wndData.modifiers) newModifiers=[...wndData.modifiers]
        let grpIdx=-1
        if(grp) grpIdx=newModifiers.findIndex(el=>el.uid===grp.uid)
        if(itm&&grpIdx!==-1){
            let itmIdx=-1
            if(newModifiers[grpIdx].child) itmIdx=newModifiers[grpIdx].child.findIndex(el=>el.uid===itm.uid)
            if(itmIdx!==-1) {
                newModifiers[grpIdx].child[itmIdx].hide=true
                for(let i=itmIdx+1;i<newModifiers[grpIdx].child[itmIdx].length;i++){
                    newModifiers[grpIdx].child[i].sorting--
                    newModifiers[grpIdx].child[i].edit=true
                }
            }
        }
        else if(itm&&itm.type>3){
            grpIdx=newModifiers.findIndex(el=>el.uid===itm.uid)
            if(grpIdx!==-1) {
                newModifiers[grpIdx].hide=true
                for(let i=grpIdx+1;i<newModifiers[grpIdx].length;i++){
                    newModifiers[i].sorting--
                    newModifiers[i].edit=true
                }
            }
        }
        else if(grp){
            if(grpIdx!==-1) {
                newModifiers[grpIdx].hide=true
                for(let i=grpIdx+1;i<newModifiers[grpIdx].length;i++){
                    newModifiers[i].sorting--
                    newModifiers[i].edit=true
                }
            }
        }
        let newData={...wndData,modifiers:newModifiers,changed:true}
        setWndData(newData)
    }
    
    //Позначки
    const modCheckItem=(grp,itm)=>{
        let newModifiers=[]
        if(wndData.modifiers) newModifiers=[...wndData.modifiers]
        let grpIdx=-1
        if(grp) grpIdx=newModifiers.findIndex(el=>el.uid===grp.uid)
        if(itm&&grpIdx!==-1){
            let itmIdx=-1
            if(newModifiers[grpIdx].child) itmIdx=newModifiers[grpIdx].child.findIndex(el=>el.uid===itm.uid)
            if(itmIdx!==-1) {
                if(newModifiers[grpIdx].type===1) { //переключатель
                    for(let i=0;i<newModifiers[grpIdx].child.length;i++){
                        if(i===itmIdx) newModifiers[grpIdx].child[i].type=3
                        else newModifiers[grpIdx].child[i].type=2
                        newModifiers[grpIdx].child[i].edit=true
                    }
                } else {
                    if(newModifiers[grpIdx].child[itmIdx].type===2) newModifiers[grpIdx].child[itmIdx].type=3
                    else newModifiers[grpIdx].child[itmIdx].type=2
                    newModifiers[grpIdx].child[itmIdx].edit=true
                }
                let newData={...wndData,modifiers:newModifiers,changed:true}
                setWndData(newData)
            }
        } else if(itm&&itm.type>3){
            grpIdx=newModifiers.findIndex(el=>el.uid===itm.uid)
            if(newModifiers[grpIdx].type===4) newModifiers[grpIdx].type=5
            else newModifiers[grpIdx].type=4
            newModifiers[grpIdx].edit=true
            let newData={...wndData,modifiers:newModifiers,changed:true}
            setWndData(newData)
        }

    }

    const empty_img='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='

    return(

    <div style={{display:'flex',flexDirection:'column', margin:'4px 0',width:'calc(100% - 6px)'}}>
    <div style={{margin:'2px 0',display:'inherit'}}>
        <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d)=>{setValue('id',d)}} width1='20' width2='50' disabled={true}/>
        <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
        <EditCtrl Capt={localestr('Назва')} Value={wndData.name} typeVal={'text'} setVal={(d)=>{setValue('name',d)}} width1='46' width2='263'/>
        <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
        <EditFld Capt={localestr('Папка')} Value={wndData.parent} typeVal={'fldGoods'} setVal={(d)=>{setValue('parent',d)}} width1='50' width2='183' />
    </div>
    <div style={{margin:'2px 0',display:'inherit'}}>
        <EditCtrl Capt={localestr('Порядок сортування')} Value={wndData.sort} typeVal={'number'} setVal={(d)=>{setValue('sort',d)}} width1='155' width2='40'/>
        <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
        <EditCtrl Capt={localestr('Колір папки')} Value={wndData.colour} typeVal={'color'} setVal={(d)=>{setValue('colour',d)}} width1='92' width2='35'/>
        <div style={{minWidth:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
        <EditCtrl Capt={localestr('Фіскальний апарат')} Value={wndData.fiscal} typeVal={'catDevices'} setVal={(d)=>{setValue('fiscal',d)}} width1='140' width2='100'/>
    </div>
    <EditImg Capt={localestr('Іконка для офіціанта')+' (100x100)'} Value={wndData.small_img||empty_img} setVal={(d)=>{setValue('small_img',d)}} width1='78' width2='90' height2='90' img_width={100} img_height={100}/>
            <div style={{minWidth:'4px',display:'inline-block',flexGrow:2,maxWidth:'8px'}}></div>
    <EditCtrl Capt={localestr('Використовувати виключно для залу')} Value={wndData.hall} typeVal={'catHalls'} setVal={(d)=>{setValue('hall',d)}} width1='267' width2='170'/>
    <div style={{margin:'2px 0',display:'inherit'}}>
        <EditCtrl Capt={localestr('Пакування')} Value={wndData.package} typeVal={'catGoods'} setVal={(d)=>{setValue('package',d)}} width1='80' width2='100'/>
        <div style={{minWidth:'140px',display:'inline-block',flexGrow:4,maxWidth:'320px',alignContent:'center',fontSize:'small',fontStyle:'italic',color:'#00F'}}>{localestr('буде додаватись у замовлення на доставку')}</div>
    </div>
    {langs_cont}
    <Panel caption={localestr('Модифікатори')} width={578} open={wndData.p_modif===undefined?false:wndData.p_modif} 
        setOpen={d=>setWndData({...wndData,p_modif:d})} info={<div style={{textAlign:'justify',maxWidth:'350px',whiteSpace:'normal'}}>
            <p>{localestr("Модифікатори — спеціальні елементи в Меню, які уточнюють блюдо: його вартість, склад, особливості приготування, побажання гостя.")}</p>
            <p>{localestr("За допомогою модифікаторів можна внести зміни в склад або процес приготування страви на касі, наприклад, вказати ступінь прожарювання м'яса, яким сиропом полити морозиво, тощо.")}</p>
            <p>{localestr("Модифікатори зазвичай об'єднують в групи.")}</p></div>}
        url={'https://cocktail.org.ua/wiki/modifiers.html'}>
        {modCont}
        <div className='no-print' style={{margin:'10px 0 0 0',minWidth:'578px',display:'flex',justifyContent:'center',flexGrow:'100000'}}>
            <div style={{width:'260px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{modGroupEdit()}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Нова група модифікаторів')}</div></div>
            <div style={{width:'260px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{modItemEdit4()}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>{localestr('Новий одиночний модифікатор')}</div></div>
        </div>
    </Panel>
    <div style={{width:'54px', display:'inline-block',verticalAlign:'bottom'}} className={'key_btn'} onClick={()=>{saveValue()}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
    </div>
    )
    
}

export default FldGoodsEdit